export default String.raw`
.categories-map{
    margin-top: 30px;
    &__title{
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
    }
    &__categories{
        display: flex;
        flex-wrap: wrap;
        gap: 25px;
    }
    .category{
        width: calc((100% - 75px)/4);
        padding: 25px;
        &__image{
            width: 100%;
            padding-top: 100%;
            position: relative;
            img{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            .no-image{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 100%;
                max-width: 160px;
                max-height: 160px;
                transform: translate(-50%, -50%);
                object-fit: contain;
                fill: #D5D5D5;
            }
        }
        &__name{
            margin-top: 25px;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
        }
    }
}
`